import { render, staticRenderFns } from "./ReportsGenderGapIndicator.vue?vue&type=template&id=87fd4cc4&scoped=true&"
import script from "./ReportsGenderGapIndicator.vue?vue&type=script&lang=js&"
export * from "./ReportsGenderGapIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ReportsGenderGapIndicator.vue?vue&type=style&index=0&id=87fd4cc4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fd4cc4",
  null
  
)

export default component.exports